function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.33333 23.668C10.6167 23.668 11.6667 22.618 11.6667 21.3346H7C7 22.618 8.05 23.668 9.33333 23.668ZM16.3333 16.668V10.8346C16.3333 7.25297 14.4317 4.25464 11.0833 3.4613V2.66797C11.0833 1.69964 10.3017 0.917969 9.33333 0.917969C8.365 0.917969 7.58333 1.69964 7.58333 2.66797V3.4613C4.24667 4.25464 2.33333 7.2413 2.33333 10.8346V16.668L0 19.0013V20.168H18.6667V19.0013L16.3333 16.668ZM14 17.8346H4.66667V10.8346C4.66667 7.9413 6.42833 5.58464 9.33333 5.58464C12.2383 5.58464 14 7.9413 14 10.8346V17.8346Z",
  fill: "#425AF2"
});

function SvgHeaderBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBell);
export default __webpack_public_path__ + "static/media/header-bell.ae432664.svg";
export { ForwardRef as ReactComponent };